import { FC } from "react";
import { IDeviceUsageStats } from "../../types";
import { Box, Chip, Typography } from "@mui/material";
import SectionCard from "./SectionCard";
import { BarChart } from "recharts";
import InfoRow from "./InfoRow";
import moment from "moment";

interface UsageStatsSectionProps {
  stats?: IDeviceUsageStats;
  isLoading: boolean;
  translate: (key: string) => string;
  totalCartridges?: number;
}

const UsageStatsSection: FC<UsageStatsSectionProps> = ({
  stats,
  isLoading,
  translate,
  totalCartridges = 0,
}) => {
  const getStatusChip = (remainingShots: number) => {
    if (remainingShots > 50) {
      return <Chip label="Bom" color="success" size="small" />;
    } else if (remainingShots > 10) {
      return <Chip label="Baixo" color="warning" size="small" />;
    }
    return <Chip label="Crítico" color="error" size="small" />;
  };

  return (
    <SectionCard
      title="Estatísticas de Uso"
      icon={<BarChart />}
      isLoading={isLoading}
    >
      {stats ? (
        <>
          <InfoRow label="Nome" value={stats.name || "N/A"} />
          <InfoRow label="Total de Disparos" value={stats.totalShots} />
          <InfoRow
            label="Último Disparo"
            value={
              stats.lastShotAt
                ? moment(stats.lastShotAt).format("DD/MM/YYYY HH:mm")
                : "Nunca"
            }
          />
          <InfoRow label="Cartuchos Configurados" value={totalCartridges} />
          <InfoRow
            label="Disparos Restantes"
            value={
              <Box display="flex" alignItems="center" gap={1}>
                {stats.remainingShots}
                {getStatusChip(stats.remainingShots)}
              </Box>
            }
          />
        </>
      ) : (
        <Typography color="text.secondary">
          Nenhuma estatística disponível
        </Typography>
      )}
    </SectionCard>
  );
};
export default UsageStatsSection;
